import Repository from './Repository'

const resource = 'exercises-details'

export default {
  getExerciseDetails (tenantId, params) {
    return Repository.get(`dw/tenants/${tenantId}/${resource}`, { params: params })
  }
}
